import React, { useEffect, useState, useCallback, useRef } from "react";
import { Modal, Button, Form, Badge, Card, Row, Col, Container, Spinner, ListGroup, Toast, ToastContainer, InputGroup, Table } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import { Link } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import Select from 'react-select';
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Menu from '../../comum/Menu/index.jsx';
import Footer from '../../comum/Footer/index.jsx';
import './index.css';

const chapaRH = localStorage.getItem("chapa");
const nomeRHLogado = localStorage.getItem("nome");

const formatarDataHora = (isoString) => {
  if (!isoString) return "";

  const data = isoString.replace("Z", "");
  const dt = new Date(data);

  const dia = String(dt.getDate()).padStart(2, "0");
  const mes = String(dt.getMonth() + 1).padStart(2, "0");
  const ano = dt.getFullYear();
  const hora = String(dt.getHours()).padStart(2, "0");
  const minuto = String(dt.getMinutes()).padStart(2, "0");
  const segundo = String(dt.getSeconds()).padStart(2, "0");

  return `${dia}/${mes}/${ano}, ${hora}:${minuto}:${segundo}`;
};


function DashboardRH() {
    const [chamados, setChamados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroStatus, setFiltroStatus] = useState("0");
    const [showAlerta, setShowAlerta] = useState(false);

    const [selected, setSelected] = useState(null);
    const [mensagens, setMensagens] = useState([]);
    const [showResponder, setShowResponder] = useState(false);
    const [respostaHtml, setRespostaHtml] = useState("");
    const [salvarFaq, setSalvarFaq] = useState(false);
    const [loadingChat, setLoadingChat] = useState(false);
    const [arquivoRH, setArquivoRH] = useState(null);

    // --- ESTADOS GESTÃO DE FAQ ---
    const [showModalFaq, setShowModalFaq] = useState(false);
    const [assuntosFaq, setAssuntosFaq] = useState([]);
    const [buscaFaq, setBuscaFaq] = useState("");
    const [faqId, setFaqId] = useState(0);
    const [faqPergunta, setFaqPergunta] = useState("");
    const [faqResposta, setFaqResposta] = useState("");
    const [faqAtivo, setFaqAtivo] = useState("S");
    const [modoFaq, setModoFaq] = useState("novo");

    const tituloRef = useRef(null);
    const qtdAnteriorRef = useRef(0);

    // --- ESTADOS CURRICULOS ---
    const [viewMode, setViewMode] = useState("chamados");
    const [curriculos, setCurriculos] = useState([]);
    const [filtroCur, setFiltroCur] = useState({ vaga: '', status: 'P', buscaLocal: '' });

    const [areasDisponiveis, setAreasDisponiveis] = useState([]);
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);

    const [showModalAvaliar, setShowModalAvaliar] = useState(false);
    const [selectedCur, setSelectedCur] = useState(null);
    const [avaliacao, setAvaliacao] = useState({
        nota: 0,
        obs: "",
        entrevistado: "N",
        entrevistador: ""
    });

    // --- ESTADOS PREVIEW ARQUIVOS ---
    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewTipo, setPreviewTipo] = useState("");
    const [previewNome, setPreviewNome] = useState("");

    // --- UTILITÁRIOS ---
    const encodeBase64 = (str) => {
        try {
            if (!str) return "";
            const bytes = new TextEncoder().encode(str);
            let binary = "";
            bytes.forEach(b => binary += String.fromCharCode(b));
            return window.btoa(binary);
        } catch (e) { return ""; }
    };

    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const pad = base64.length % 4;
            if (pad !== 0) base64 += "=".repeat(4 - pad);
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            return new TextDecoder("utf-8").decode(bytes);
        } catch (e) { return str; }
    };

    // =========================================================
    // BUSCAR E ABRIR ARQUIVO DO CHAMADO (MODAL)
    // =========================================================
    const handleBuscarEVerArquivoChamado = async (idChamado, idInteracao, nomeArquivo) => {
        try {
            setLoading(true);
            const response = await api.get(`/rh/chamado/${idChamado}/arquivo?id_interacao=${idInteracao}`);
            const dados = response.data;

            console.log("Resposta do arquivo:", dados);

            const base64Dados =
                (Array.isArray(dados) && dados.length > 0 &&
                    (dados[0].anexo_blob || dados[0].ANEXO_BLOB || dados[0].anexo_base64 || dados[0].ANEXO_BASE64)) ||
                dados?.anexo_blob ||
                dados?.ANEXO_BLOB ||
                dados?.anexo_base64 ||
                dados?.ANEXO_BASE64;

            if (base64Dados) {
                abrirPreviewArquivo(base64Dados, nomeArquivo);
            } else {
                Swal.fire('Aviso', 'Arquivo não encontrado no servidor.', 'warning');
            }
        } catch (err) {
            console.error('Erro ao buscar arquivo:', err);
            Swal.fire('Erro', 'Falha ao recuperar o anexo.', 'error');
        } finally {
            setLoading(false);
        }
    };

    // =========================================================
    // BUSCAR E ABRIR CURRÍCULO (MODAL)
    // =========================================================
    const handleBuscarEVerCurriculo = async (email, nomeArquivo) => {
        try {
            setLoading(true);
            const response = await api.get(`/rh/curriculos/arquivo?email=${email}`);
            console.log('Resposta da API:', response.data);

            let base64Dados = "";

            if (Array.isArray(response.data) && response.data.length > 0) {
                const item = response.data[0];
                base64Dados = item.curriculo_blob || item.CURRICULO_BLOB || item.curriculo_base64 || item.CURRICULO_BASE64;
            } else if (response.data) {
                base64Dados = response.data.curriculo_blob || response.data.CURRICULO_BLOB || response.data.curriculo_base64 || response.data.CURRICULO_BASE64;
            }

            if (base64Dados) {
                abrirPreviewArquivo(base64Dados, nomeArquivo || "curriculo.pdf");
            } else {
                Swal.fire('Aviso', 'O registro foi encontrado, mas o campo do arquivo está vazio no servidor.', 'warning');
            }
        } catch (err) {
            console.error('Erro na requisição:', err);
            Swal.fire('Erro', 'Não foi possível conectar ao servidor para baixar o arquivo.', 'error');
        } finally {
            setLoading(false);
        }
    };

    // =========================================================
    // ABRIR BASE64 EM MODAL (PDF / IMAGEM / DOWNLOAD)
    // =========================================================
    const abrirPreviewArquivo = (base64Dados, nomeArquivo) => {
        try {
            if (!base64Dados) return Swal.fire('Erro', 'Conteúdo do arquivo não encontrado.', 'error');

            const base64Limpo = base64Dados
                .replace(/^data:.*;base64,/, "")
                .replace(/\r?\n|\r/g, "")
                .replace(/\s/g, "")
                .trim();

            const byteCharacters = atob(base64Limpo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            let type = "application/octet-stream";
            const ext = (nomeArquivo || "").toLowerCase();
            if (ext.endsWith(".pdf")) type = "application/pdf";
            else if (ext.endsWith(".png")) type = "image/png";
            else if (ext.endsWith(".jpg") || ext.endsWith(".jpeg")) type = "image/jpeg";

            const blob = new Blob([byteArray], { type });
            const url = URL.createObjectURL(blob);

            setPreviewUrl(url);
            setPreviewTipo(type);
            setPreviewNome(nomeArquivo || "arquivo");
            setShowPreview(true);
        } catch (err) {
            console.error("Erro ao abrir arquivo:", err);
            Swal.fire('Erro', 'Falha ao abrir o arquivo.', 'error');
        }
    };

    // --- LOGICA CHAMADOS ---
    const loadChamados = useCallback(async (isPolling = false) => {
        if (viewMode !== 'chamados') return;
        if (!isPolling) setLoading(true);
        try {
            const response = await api.get(`/rh/dashboard?status=${filtroStatus}`);
            const novosDados = response.data || [];
            if (filtroStatus === "0" && novosDados.length > qtdAnteriorRef.current && qtdAnteriorRef.current !== 0) {
                setShowAlerta(true);
            }
            qtdAnteriorRef.current = novosDados.length;
            setChamados(novosDados);
        } catch (err) { console.error(err); } finally { setLoading(false); }
    }, [filtroStatus, viewMode]);

    // --- LOGICA CURRICULOS ---
    const loadCurriculos = useCallback(async () => {
        setLoading(true);
        try {
            let vagaParam = '';
            let statusParam = filtroCur.status;

            if (areasSelecionadas.length > 0) {
                vagaParam = areasSelecionadas.map(a => a.value).join(',');
                statusParam = '';
            } else {
                vagaParam = filtroCur.vaga;
            }

            const res = await api.get(`/rh/curriculos?area=${vagaParam}&status=${statusParam}`);
            let dados = res.data || [];
            if (areasSelecionadas.length > 0) {
                dados.sort((a, b) => (b.classificacao_nota || 0) - (a.classificacao_nota || 0));
            }

            if (filtroCur.buscaLocal) {
                const termo = filtroCur.buscaLocal.toLowerCase();
                dados = dados.filter(cur =>
                    (cur.nome_candidato || '').toLowerCase().includes(termo) ||
                    (cur.endereco_completo || '').toLowerCase().includes(termo) ||
                    (cur.loja_preferencia || '').toLowerCase().includes(termo) ||
                    (cur.vaga_interesse || '').toLowerCase().includes(termo)
                );
            }

            setCurriculos(dados);
        } catch (err) { console.error(err); } finally { setLoading(false); }
    }, [filtroCur, areasSelecionadas]);

    const loadAreas = async () => {
        try {
            const res = await api.get('/externo/areas');
            const lista = (res.data || []).map(a => ({
                value: a.id_area || a.ID_AREA,
                label: a.descricao || a.DESCRICAO
            }));
            setAreasDisponiveis(lista);

        } catch (err) { console.error(err); }
    };

    useEffect(() => {
        if (viewMode === 'chamados') {
            loadChamados();
            const interval = setInterval(() => loadChamados(true), 20000);
            return () => clearInterval(interval);
        } else {
            loadAreas();
            loadCurriculos();
        }
    }, [loadChamados, loadCurriculos, viewMode]);

    const abrirAvaliacao = (cur) => {
        setSelectedCur(cur);
        setAvaliacao({
            nota: cur.classificacao_nota || 0,
            obs: cur.obs_entrevista || "",
            entrevistado: cur.ja_entrevistado || "N",
            entrevistador: cur.entrevistador || ""
        });
        setShowModalAvaliar(true);
    };

    const handleSalvarAvaliacao = async () => {
        if (avaliacao.nota === 0) return Swal.fire("Aviso", "Selecione uma nota de 1 a 5.", "warning");
        try {
            await api.post('/rh/curriculo/avaliar', {
                id_candidato: selectedCur.id_candidato,
                classificacao_nota: avaliacao.nota,
                obs_entrevista: encodeBase64(avaliacao.obs),
                ja_entrevistado: avaliacao.entrevistado,
                entrevistador: nomeRHLogado
            });
            Swal.fire("Sucesso", "Avaliação gravada com sucesso!", "success");
            setShowModalAvaliar(false);
            loadCurriculos();
        } catch (err) {
            Swal.fire("Erro", "Falha ao gravar avaliação.", "error");
            console.log(err);
        }
    };

    // --- METODOS ORIGINAIS FAQ/CHAMADOS ---
    const loadAssuntosFaq = async () => {
        try {
            const res = await api.get('/rh/assuntos');
            setAssuntosFaq(res.data || []);
        } catch (err) { console.error(err); }
    };

    const handleAbrirResposta = async (chamado) => {
        const id = chamado?.id_chamado || chamado?.ID_CHAMADO;
        if (!id) return;
        setSelected(chamado);
        setRespostaHtml("");
        setSalvarFaq(false);
        setArquivoRH(null);
        setShowResponder(true);
        setLoadingChat(true);
        try {
            const res = await api.get(`/rh/chamado/${id}/interacoes`);
            setMensagens(res.data || []);
        } catch (err) { setMensagens([]); } finally { setLoadingChat(false); }
    };

    const handleEnviarResposta = async () => {
        const textoPuro = respostaHtml.replace(/<(.|\n)*?>/g, '').trim();
        if (!textoPuro) return Swal.fire('Atenção', 'Digite uma resposta!', 'warning');
        try {
            setLoading(true);
            let base64File = "";
            if (arquivoRH) {
                const reader = new FileReader();
                base64File = await new Promise((resolve, reject) => {
                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(arquivoRH);
                });
            }
            const payload = {
                id_chamado: selected?.id_chamado || selected?.ID_CHAMADO,
                id_assunto: selected?.id_assunto || selected?.ID_ASSUNTO,
                chapa: chapaRH,
                mensagem: encodeBase64(respostaHtml),
                anexo_base64: base64File,
                nome_arquivo: arquivoRH ? arquivoRH.name : "",
                salvar_faq: salvarFaq
            };
            await api.post('/rh/responder', payload);
            Swal.fire('Sucesso', 'Resposta enviada!', 'success');
            setShowResponder(false);
            loadChamados();
        } catch (err) {
            Swal.fire('Erro', 'Erro ao enviar resposta.', 'error');
        } finally { setLoading(false); }
    };

    const selecionarParaEditar = (item) => {
        const id = Number(item.id_assunto ?? item.ID_ASSUNTO);
        const titulo = item.descricao_assunto || item.DESCRICAO_ASSUNTO || "";
        const textoBase64 = item.texto_faq_assunto || item.TEXTO_FAQ_ASSUNTO || "";
        const ativo = item.ativo_assunto || item.ATIVO_ASSUNTO || "S";
        let respostaDecodificada = "";
        if (textoBase64) {
            try {
                const step1 = decodeBase64(textoBase64);
                respostaDecodificada = decodeBase64(step1) || step1;
            } catch {
                respostaDecodificada = decodeBase64(textoBase64);
            }
        }
        setModoFaq("edicao");
        setFaqId(id);
        setFaqPergunta(titulo);
        setFaqResposta(respostaDecodificada);
        setFaqAtivo(ativo);
        setTimeout(() => tituloRef.current?.focus(), 50);
    };

    const prepararNovaFaq = () => {
        setModoFaq("novo");
        setFaqId(Math.random());
        setFaqPergunta("");
        setFaqResposta("");
        setFaqAtivo("S");
        setTimeout(() => { setFaqId(0); tituloRef.current?.focus(); }, 10);
    };

    const handleSalvarFaqDireto = async () => {
        if (!faqPergunta.trim()) return Swal.fire("Aviso", "O Título do Assunto não pode estar vazio!", "warning");
        try {
            const payload = {
                id_assunto: modoFaq === "novo" ? 0 : faqId,
                descricao_assunto: faqPergunta,
                texto_faq_assunto: encodeBase64(faqResposta),
                ativo_assunto: faqAtivo
            };
            await api.post('/rh/faq/manutencao', payload);
            Swal.fire("Sucesso", modoFaq === "novo" ? "FAQ cadastrada!" : "FAQ atualizada!", "success");
            await loadAssuntosFaq();
            prepararNovaFaq();
        } catch (err) { Swal.fire("Erro", "Falha ao gravar FAQ.", "error"); }
    };

    const faqsFiltradas = assuntosFaq.filter(a => (a.descricao_assunto || a.DESCRICAO_ASSUNTO || "").toLowerCase().includes(buscaFaq.toLowerCase()));
    const podeResponder = (selected?.status_chamado ?? selected?.STATUS_CHAMADO) === 0;

    return (
        <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: '#f4f7f6' }}>
            <Menu modulo="ARBOR" />
            <ToastContainer position="top-end" className="p-3">
                <Toast show={showAlerta} onClose={() => setShowAlerta(false)} bg="primary" delay={5000} autohide>
                    <Toast.Header><strong className="me-auto">🔔 Novo Chamado</strong></Toast.Header>
                    <Toast.Body className="text-white">Há novas solicitações na fila!</Toast.Body>
                </Toast>
            </ToastContainer>

            <Container className="flex-grow-1 py-4">
                <Row>
                    <Col md={3} className="mb-4">
                        <Card className="shadow-sm border-0 sticky-top" style={{ top: '20px' }}>
                            <Card.Header className="bg-white fw-bold">Navegação</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item action active={viewMode === 'chamados'} onClick={() => setViewMode('chamados')}>💬 Chamados RH</ListGroup.Item>
                                <ListGroup.Item action active={viewMode === 'curriculos'} onClick={() => setViewMode('curriculos')}>📄 Banco de Currículos</ListGroup.Item>
                            </ListGroup>

                            {viewMode === 'chamados' && (
                                <>
                                    <Card.Header className="bg-white fw-bold border-top mt-2">Status Chamados</Card.Header>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item action active={filtroStatus === "0"} onClick={() => setFiltroStatus("0")}>📥 Pendentes</ListGroup.Item>
                                        <ListGroup.Item action active={filtroStatus === "2"} onClick={() => setFiltroStatus("2")}>✅ Respondidos</ListGroup.Item>
                                        <ListGroup.Item action active={filtroStatus === "3"} onClick={() => setFiltroStatus("3")}>🔒 Finalizados</ListGroup.Item>
                                    </ListGroup>
                                </>
                            )}

                            {viewMode === 'curriculos' && (
                                <>
                                    <Card.Header className="bg-white fw-bold border-top mt-2">Status Currículos</Card.Header>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item action active={filtroCur.status === "P"} onClick={() => setFiltroCur({ ...filtroCur, status: "P" })}>📥 Pendentes</ListGroup.Item>
                                        <ListGroup.Item action active={filtroCur.status === "A"} onClick={() => setFiltroCur({ ...filtroCur, status: "A" })}>✅ Avaliados</ListGroup.Item>
                                    </ListGroup>
                                </>
                            )}

                            <ListGroup variant="flush">
                                <ListGroup.Item action className="text-primary fw-bold border-top mt-2" onClick={() => { loadAssuntosFaq(); setShowModalFaq(true); }}>⚙️ Gerenciar FAQs</ListGroup.Item>
                            </ListGroup>
                        </Card>
                    </Col>

                    <Col md={9}>
                        {viewMode === 'curriculos' ? (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="fw-bold text-secondary">Banco de Currículos</h5>
                                    <Badge bg="dark">Total: {curriculos.length}</Badge>
                                </div>
                                <Card className="filtro-cv mb-6 border-0 shadow-sm p-3">
                                    <Row className="filtro-cv">
                                        <Col md={5}>
                                            <Form.Control
                                                size="sm"
                                                placeholder="Buscar por nome, endereço, loja, área..."
                                                value={filtroCur.buscaLocal}
                                                onChange={e => setFiltroCur({ ...filtroCur, buscaLocal: e.target.value })}
                                            />
                                        </Col>

                                        <Col md={5}>
                                            <Select
                                                isMulti
                                                options={areasDisponiveis}
                                                placeholder="Selecione as áreas..."
                                                value={areasSelecionadas}
                                                onChange={setAreasSelecionadas}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />
                                        </Col>

                                        <Col md={2}>
                                            <Button variant="primary" size="sm" className="w-100" onClick={loadCurriculos}>
                                                Buscar
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card>
                                <Card className="candidatos border-0 shadow-sm mb-4">
                                    <Table hover responsive className="mb-0">
                                        <thead className="bg-light x-small">
                                            <tr>
                                                <th>CANDIDATO</th>
                                                <th className="text-center">NOTA</th>
                                                <th className="text-center">ENTREVISTA</th>
                                                <th className="text-center">AÇÕES</th>
                                            </tr>
                                        </thead>
                                        <tbody className="small">
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4">
                                                        <Spinner animation="border" size="sm" />
                                                    </td>
                                                </tr>
                                            ) : (
                                                curriculos.map(cur => (
                                                    <tr key={cur.id_candidato}>
                                                        <td>
                                                            <div className="text-uppercase fw-bold">{cur.nome_candidato}</div>
                                                            <div className="text-muted small">{cur.areas_descricoes || 'Geral'}</div>
                                                            <div className="text-danger small">{formatarDataHora(cur.data_cadastro) || ''}</div>
                                                        
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <Badge bg={cur.classificacao_nota >= 4 ? "success" : cur.classificacao_nota >= 3 ? "warning" : "danger"}>
                                                                {cur.classificacao_nota || 0}/5
                                                            </Badge>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            {cur.ja_entrevistado === 'S' ? <Badge bg="info">SIM</Badge> : <Badge bg="secondary">NÃO</Badge>}
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <Button
                                                                variant="primary"
                                                                size="sm"
                                                                className="py-0 px-2"
                                                                onClick={() => abrirAvaliacao(cur)}
                                                            >
                                                                Analisar
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>

                                </Card>
                            </>
                        ) : (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="fw-bold text-secondary">Gestão de Chamados RH</h5>
                                    <Badge bg="dark">Total: {chamados.length}</Badge>
                                </div>
                                {loading && <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>}
                                <div className="lista-chamados">
                                    {!loading && chamados.map(item => (
                                        <Card key={item.id_chamado || item.ID_CHAMADO} className="mb-3 border-0 shadow-sm card-rh-item" onClick={() => handleAbrirResposta(item)}>
                                            <Card.Body>
                                                <Row className="align-items-center">
                                                    <Col md={8}>
                                                        <Badge bg="info" className="mb-2">#{item.id_chamado || item.ID_CHAMADO}</Badge>
                                                        <div className="fw-bold text-uppercase">{item.nome_func || item.NOME_FUNC || item.nome_candidato || item.NOME_CANDIDATO}</div>
                                                        <div className="text-primary fw-bold small mb-1">{item.descricao_assunto || item.DESCRICAO_ASSUNTO}</div>
                                                        <div className="small text-muted text-truncate"
                                                            dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(item.pergunta_chamado || item.PERGUNTA_CHAMADO)) }} />
                                                    </Col>
                                                    <Col md={4} className="text-end">
                                                        <small className="d-block text-muted mb-2">{formatarDataHora(item.ultimainteracao)}</small>
                                                        <Button variant={(item.status_chamado ?? item.STATUS_CHAMADO) === 0 ? "primary" : "outline-secondary"} size="sm">
                                                            {(item.status_chamado ?? item.STATUS_CHAMADO) === 0 ? "Atender" : "Visualizar"}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>

            {/* MODAL ANALISE - COMPACTADO */}
            {/* MODAL DOSSIÊ (MODIFICADA) */}
            <Modal show={showModalAvaliar} onHide={() => setShowModalAvaliar(false)} size="xl" centered scrollable>
                <Modal.Header closeButton className="bg-dark text-white p-2 px-3">
                    <Modal.Title className="fs-6">Dossiê do Candidato: {selectedCur?.nome_candidato}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <Row className="g-0">
                        <Col md={7} className="p-4 border-end bg-light">
                            <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">Dados Pessoais</h6>
                            <Row className="gy-3">
                                <Col md={12}>
                                    <label className="fw-bold text-muted d-block small">{selectedCur?.nome_candidato}</label>

                                </Col>
                                <Col md={6}>
                                    <label className="fw-bold text-muted d-block small">✉️ Email</label>
                                    <span className="small">{selectedCur?.email_candidato}</span>
                                </Col>
                                <Col md={6}>
                                    <label className="fw-bold text-muted d-block small">📱 Telefone</label>
                                    <span className="small">{selectedCur?.telefone_candidato}</span>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">🎂 Nasc:</label>
                                    <span className="small">{selectedCur?.dta_nascimento ? new Date(selectedCur.dta_nascimento).toLocaleDateString() : '-'}</span>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">💍 Civil:</label>
                                    <span className="small">{selectedCur?.estado_civil}</span>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">🧒🏻 Filhos:</label>
                                    <span className="small">{selectedCur?.tem_filhos}</span>
                                </Col>

                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">🎓 Escolaridade</label>
                                    <span className="small">{selectedCur?.escolaridade}</span>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">🪪 CNH</label>
                                    <span className="small">{selectedCur?.cnh_categoria || 'Não possui'}</span>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">🧬 Etnia:</label>
                                    <span className="small">{selectedCur?.etnia_ibge}</span>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">⚧ Gênero:</label>
                                    <span className="small"><a>{selectedCur?.genero_identidade}</a></span>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">🔗 Linkedin:</label>
                                    <a
                                        href={selectedCur?.link_linkedin}
                                        className="dropdown-item"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{selectedCur?.link_linkedin
                                        ? selectedCur.link_linkedin.split('/in/')[1]?.replace(/\/$/, '')
                                        : ''}
                                    </a>
                                </Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">👫🏻 Familiar:</label>
                                    <span className="small"><a>{selectedCur?.familiar_floresta}</a></span>
                                </Col>
                                <Col md={12}>
                                    <label className="fw-bold text-muted d-block small">🏠 Endereço Completo</label>
                                    <span className="small">{selectedCur?.endereco_completo}</span>
                                </Col>
                                <Col md={6}>
                                    <label className="fw-bold text-muted d-block small">🏪 Loja Preferência</label>
                                    <Badge bg="info">{selectedCur?.loja_preferencia}</Badge>
                                </Col>
                                <Col md={6}>
                                    <label className="fw-bold text-muted d-block small">💰 Pretensão Salarial</label>
                                    <span className="fw-bold text-success small">R$ {Number(selectedCur?.valor_pretensao).toLocaleString()}</span>
                                </Col>
                                <Col md={12}>
                                    <label className="fw-bold text-muted d-block small">🗓️ Última Alteração</label>
                                    <span className="small">{selectedCur?.dta_alteracao ? new Date(selectedCur.dta_alteracao).toLocaleString() : '-'}</span>
                                </Col>

                                <Col md={12}>
                                    <label className="fw-bold text-muted d-block small">🧾 Áreas de Interesse</label>
                                    <span className="small">{selectedCur?.areas_descricoes}</span>
                                </Col>
                            </Row>
                            <hr />
                            <h6 className="fw-bold text-primary mb-2">Apresentação</h6>
                            <div className="p-3 border rounded bg-white overflow-auto mb-3" style={{ maxHeight: '200px' }}
                                dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(selectedCur?.texto_apresentacao)) }} />
                            <Button
                                variant="danger"
                                className="w-100"
                                onClick={() => handleBuscarEVerCurriculo(selectedCur?.email_candidato, selectedCur?.nome_arquivo)}
                            >
                                Curriculo Enviado
                            </Button>
                        </Col>
                        <Col md={5} className="p-4 bg-white">
                            <h6 className="fw-bold text-success border-bottom pb-2 mb-4">Avaliação do RH</h6>
                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">Classificação (Nota)</Form.Label>
                                <div className="d-flex justify-content-between">
                                    {[1, 2, 3, 4, 5].map(n => (
                                        <Button key={n} variant={avaliacao.nota === n ? "primary" : "outline-secondary"} onClick={() => setAvaliacao({ ...avaliacao, nota: n })}>{n}</Button>
                                    ))}
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">Já foi entrevistado?</Form.Label>
                                <Form.Select size="sm" value={avaliacao.entrevistado} onChange={e => setAvaliacao({ ...avaliacao, entrevistado: e.target.value })}>
                                    <option value="N">Não</option><option value="S">Sim</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">Observações Internas</Form.Label>
                                <Form.Control as="textarea" rows={6} value={decodeBase64(decodeBase64(avaliacao.obs))} onChange={e => setAvaliacao({ ...avaliacao, obs: e.target.value })} placeholder="Descreva aqui o parecer..." />
                            </Form.Group>
                            <Button variant="success" className="w-100 mt-2 shadow-sm" onClick={handleSalvarAvaliacao}>Gravar Avaliação</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* MODAIS ORIGINAIS FAQ E RESPOSTA */}
            <Modal show={showModalFaq} onHide={() => setShowModalFaq(false)} size="lg" centered scrollable>
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title className="fs-6 fw-bold">Gestão de Conteúdo FAQ</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '75vh' }}>
                    <Row>
                        <Col md={5} className="border-end">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="fw-bold small">1. Selecione ou crie</span>
                                <Button variant="success" size="sm" style={{ fontSize: '10px' }} onClick={prepararNovaFaq}>+ NOVO ASSUNTO</Button>
                            </div>
                            <InputGroup size="sm" className="mb-2">
                                <Form.Control placeholder="Pesquisar..." value={buscaFaq} onChange={(e) => setBuscaFaq(e.target.value)} />
                            </InputGroup>
                            <ListGroup variant="flush" className="border rounded overflow-auto" style={{ maxHeight: '400px' }}>
                                {faqsFiltradas.map(a => {
                                    const idItem = Number(a.id_assunto ?? a.ID_ASSUNTO);
                                    const isSelected = modoFaq === "edicao" && faqId === idItem;
                                    return (
                                        <ListGroup.Item key={idItem} action className={`small py-2 ${isSelected ? 'active' : ''}`} onClick={() => selecionarParaEditar(a)} style={{ cursor: 'pointer' }}>
                                            {a.descricao_assunto || a.DESCRICAO_ASSUNTO}
                                            {(a.texto_faq_assunto || a.TEXTO_FAQ_ASSUNTO) &&
                                                <Badge bg={isSelected ? "light" : "success"} text={isSelected ? "dark" : "white"} className="ms-1" pill style={{ fontSize: '8px' }}>FAQ</Badge>
                                            }
                                        </ListGroup.Item>
                                    );
                                })}
                            </ListGroup>
                        </Col>
                        <Col md={7} key={faqId}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <Form.Label className="fw-bold small mb-0 text-primary">{modoFaq === "novo" ? "2. Cadastrar Nova FAQ" : "2. Editar FAQ Selecionada"}</Form.Label>
                                <Form.Check type="switch" id="switch-ativo" label={faqAtivo === "S" ? "Ativa" : "Inativa"} className={`small fw-bold ${faqAtivo === "S" ? "text-success" : "text-danger"}`} checked={faqAtivo === "S"} onChange={(e) => setFaqAtivo(e.target.checked ? "S" : "N")} />
                            </div>
                            <Form.Group className="mb-2">
                                <Form.Label className="x-small text-muted mb-0">Título do Assunto</Form.Label>
                                <Form.Control ref={tituloRef} size="sm" type="text" defaultValue={faqPergunta} onChange={(e) => setFaqPergunta(e.target.value)} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className="x-small text-muted mb-0">Resposta (Editor)</Form.Label>
                                <div className="quill-editor-container">
                                    <ReactQuill theme="snow" value={faqResposta} onChange={setFaqResposta} />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" size="sm" onClick={() => setShowModalFaq(false)}>Fechar</Button>
                    <Button variant={modoFaq === "novo" ? "primary" : "success"} size="sm" onClick={handleSalvarFaqDireto}>{modoFaq === "novo" ? "Criar FAQ" : "Salvar Alterações"}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showResponder} onHide={() => setShowResponder(false)} size="lg" centered scrollable>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fs-6 fw-bold">{podeResponder ? "Atendimento" : "Consulta"} #{selected?.id_chamado || selected?.ID_CHAMADO}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-chat-rh">
                    <div className="mb-4">
                        <h6 className="fw-bold border-bottom pb-2 small">Histórico de Mensagens</h6>
                        {loadingChat ? <div className="text-center py-3"><Spinner animation="border" size="sm" /></div> :
                            mensagens.map((m, idx) => (
                                <div key={idx} className={`mb-3 p-3 rounded shadow-sm ${m.tipo_autor === 'U' ? 'bg-white border-start border-4 border-info' : 'bg-light border-start border-4 border-success'}`}>
                                    <div className="d-flex justify-content-between mb-1">
                                        <small className="fw-bold">{m.tipo_autor === 'U' ? `👤 ${m.nome || 'INTERESSADO'}` : `🏢 RH: ${m.nome || nomeRHLogado}`}</small>
                                        <small className="text-muted" style={{ fontSize: '10px' }}>{formatarDataHora(m.datahora_interacao)}</small>
                                    </div>
                                    <div className="small text-break" dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(m.mensagem)) }} />
                                    {m.anexo_nome && (
                                        <div className="mt-2 border-top pt-1">
                                            <Button
                                                variant="link"
                                                size="sm"
                                                className="p-0 text-decoration-none fw-bold"
                                                onClick={() =>
                                                    handleBuscarEVerArquivoChamado(
                                                        selected?.id_chamado || selected?.ID_CHAMADO,
                                                        m.id_interacao || m.ID_INTERACAO,
                                                        m.anexo_nome
                                                    )
                                                }
                                            >
                                                📎 {m.anexo_nome}
                                            </Button>
                                        </div>
                                    )}

                                </div>
                            ))}
                    </div>
                    {podeResponder && (
                        <div className="mt-3 border-top pt-3">
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-bold small text-primary">Sua Resposta:</Form.Label>
                                <div className="quill-editor-container"><ReactQuill theme="snow" value={respostaHtml} onChange={setRespostaHtml} /></div>
                            </Form.Group>
                            <Form.Group><Form.Label className="x-small">Anexar Arquivo</Form.Label><Form.Control type="file" size="sm" onChange={(e) => setArquivoRH(e.target.files[0])} /></Form.Group>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowResponder(false)}>Fechar</Button>
                    {podeResponder && <Button variant="primary" size="sm" onClick={handleEnviarResposta} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : "Enviar Resposta"}</Button>}
                </Modal.Footer>
            </Modal>

            {/* MODAL PREVIEW DE ARQUIVO */}
            <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fs-6 fw-bold">{previewNome}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: "60vh" }}>
                    {previewTipo === "application/pdf" && (
                        <iframe
                            src={previewUrl}
                            title="Preview PDF"
                            style={{ width: "100%", height: "70vh", border: "none" }}
                        />
                    )}

                    {(previewTipo === "image/png" ||
                        previewTipo === "image/jpeg" ||
                        previewTipo === "image/jpg") && (
                            <img
                                src={previewUrl}
                                alt="Preview"
                                style={{ maxWidth: "100%", maxHeight: "70vh", display: "block", margin: "0 auto" }}
                            />
                        )}

                    {!previewTipo.startsWith("image/") &&
                        previewTipo !== "application/pdf" && (
                            <div className="text-center">
                                <p className="mb-3">Não é possível exibir este tipo de arquivo.</p>
                                <Button
                                    variant="primary"
                                    onClick={() => {
                                        const link = document.createElement("a");
                                        link.href = previewUrl;
                                        link.download = previewNome;
                                        link.click();
                                    }}
                                >
                                    Baixar arquivo
                                </Button>
                            </div>
                        )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPreview(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer />
            <style>{`
            /* Garante que o conteúdo empurre o footer para baixo */
            .flex-grow-1 {
                flex: 1 0 auto;
            }

            /* Ajuste de Scroll para os Modais de Dossiê e FAQ */
            .modal-body {
                max-height: calc(100vh - 120px); /* Garante scroll se o conteúdo for maior que a tela */
                overflow-y: auto;
            }

            /* Fix para o Footer não sobrepor conteúdo */
            footer {
                flex-shrink: 0;
            }

            /* Ajuste para o formulário de avaliação caber melhor em telas menores */
            @media (max-width: 768px) {
                .modal-xl {
                    margin: 0.5rem;
                }
            }

            /* Mantendo seus estilos originais de cores e transições */
            .ql-container.ql-snow { color: #000000 !important; background-color: #ffffff !important; }
            .ql-editor, .ql-editor * { color: #000000 !important; -webkit-text-fill-color: #000000 !important; }
            .bg-chat-rh .small.text-break, .bg-chat-rh .small.text-break * { color: #212529 !important; }
            .card-rh-item { cursor: pointer; transition: 0.2s; border-left: 5px solid transparent; }
            .card-rh-item:hover { border-left: 5px solid #0d6efd; background-color: #fff; transform: translateY(-2px); }
            .bg-chat-rh { background-color: #f8f9fa; max-height: 60vh; }
            .ql-container { min-height: 150px; }
            .ql-toolbar { background: #eee !important; }
            .x-small { font-size: 0.72rem; font-weight: bold; text-transform: uppercase; }
            .list-group-item.active { background-color: #0d6efd !important; border-color: #0d6efd !important; }
        `}</style>

        </div>
    );
}

export default DashboardRH;
